mutation DeleteBroadcast($id: ID!) {
    campaignDelete(input: {id: $id}) {
        campaign {
            id
        }
    }
}
